const PLURALS = {
  hora: "horas",
  funcionário: "funcionários",
  funcionario: "funcionários",
  ponto: "pontos",
  amostra: "amostras",
  unidade: "unidades",
  medição: "medições",
  medicao: "medições",
  avaliação: "avaliações",
  avaliacao: "avaliações",
  visita: "visitas",
  ensaio: "ensaios",
  coleta: "coletas",
  participante: "participantes",
  colaborador: "colaboradores",
};

const isOne = (value) => Number(value) === 1;

const numberText = (value) => {
  const number = Number(value || 0);
  if (Number.isInteger(number)) return String(number);
  return new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 2 }).format(number);
};

export const pluralizePt = (singular, explicitPlural) => {
  const clean = String(singular || "").trim();
  if (!clean) return "itens";
  if (explicitPlural) return explicitPlural;
  const key = clean.toLocaleLowerCase("pt-BR");
  if (PLURALS[key]) return PLURALS[key];
  if (key.endsWith("s")) return clean;
  if (key.endsWith("ção")) return `${clean.slice(0, -3)}ções`;
  if (key.endsWith("m")) return `${clean.slice(0, -1)}ns`;
  if (/[rz]$/.test(key)) return `${clean}es`;
  if (/[aeiou]$/.test(key)) return `${clean}s`;
  return `${clean}s`;
};

export const quantityText = (value, singular, plural) =>
  `${numberText(value)} ${isOne(value) ? singular : pluralizePt(singular, plural)}`;

export const hoursText = (value) => quantityText(value, "hora", "horas");
export const employeesText = (value) => quantityText(value, "funcionário", "funcionários");
export const evaluationUnitText = (value, unit = "unidade") => quantityText(value, unit || "unidade");

export const technicalVisitsText = (value, withContract = false) => {
  const base = isOne(value)
    ? `${numberText(value)} visita técnica prevista`
    : `${numberText(value)} visitas técnicas previstas`;
  return withContract ? `${base} no contrato` : base;
};
